import { Col } from "react-bootstrap"
import { Input } from "../Input"
import { useTranslation } from "react-i18next";
import { DefaultInput } from "../DefaultInput";
import { SellingStrategyValueInput } from "../SellingStrategyValueInput";

interface CampaignCGRPSellingStrategyProps {
    setValues: (value: any, key: string, isUserSelection?: boolean) => void;
    inputValues: any;
    overrideDiscountRate: boolean;
    onOverrideDiscountRateClick: (value: boolean) => void;
}

export const CampaignCGRPSellingStrategy = (props: CampaignCGRPSellingStrategyProps) => {
    const { t } = useTranslation();
    
    return (
        <>
            <Col className="multipleInputsRow">
                <Input required title={t("txt_net_budget")}>
                    <DefaultInput
                        onChange={(value: any) => props.setValues(parseFloat(value), "fullBudget", true)}
                        type="currency"
                        iconKey="currency"
                        placeholder={t("txt_net_budget")}
                        value={props.inputValues.fullBudget}
                        params={{numberMaxValue: 9999999999, numberIsInterger: true}}
                    />
                </Input>
            </Col>
            <Col className="multipleInputsRow">
                <Input
                    required
                    title={t("txt_method_discount")}
                    checkbox={{
                        display: true,
                        title: t("txt_custom_rate"),
                        id: 'customRateCheck',
                        checked: props.overrideDiscountRate,
                        onChange: props.onOverrideDiscountRateClick,
                        className: "directAdvertiserCheck"
                    }}
                >
                    <SellingStrategyValueInput
                        setValues={(value, key) => props.setValues(value, key)}
                        disabled={!props.overrideDiscountRate}
                        iconKey="percent"
                        valuekey="discountRate"
                        value={props.inputValues.discountRate ? props.inputValues.discountRate : 0}
                        isPercentage={true}
                    />
                </Input>
            </Col>
            <Col className="multipleInputsRow">
                <Input
                    required
                    title={t("txt_method_grpcc")}
                >
                    <SellingStrategyValueInput
                        disabled={false}
                        iconKey="currency"
                        setValues={(value, key) => props.setValues(value, key)}
                        value={props.inputValues.sellingStrategyValue ? props.inputValues.sellingStrategyValue : 0}
                    />
                </Input>
            </Col>
        </>
    )
}